import App from '@/App.vue';
import '@fortawesome/fontawesome-free/css/all.css';
import 'document-register-element';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import { vuetify } from './plugins';
import store from './store';
import { i18n } from '@/plugins/i18n';
import { apiClient } from '@/plugins/api';
import '@/plugins/tooltip';

Vue.use(vueCustomElement);
Vue.config.productionTip = false;

Vue.customElement('creative-configurator', new Vue({
  store,
  // @ts-ignore
  vuetify,
  i18n,
  apiClient,
  props: ['configuration'],
  created() {
    if (this.configuration) {
      const confStr = this.configuration.split('\'').join('\"');
      const configuration = JSON.parse(confStr);
      this.$store.commit('setConfiguration', configuration);
    }
  },
  render: (h) => h(App),
}).$options);
